export const TagCategories = (listings, query) => {
  tagListings(listings, query)
}

function tagListings(listings, query) {
  // GA4
  const relatedListingsData = listings.map((listing, index) => ({ ...listing.analytics_data_attributes, index }))
  pushEcommerceEvent({
    event: "view_item_list",
    ecommerce: {
      item_list_id: "related_products",
      item_list_name: "Related products",
      items: relatedListingsData,
    },
  })
}
export default { TagCategories }
